import React from "react";

import ExternalLink from "src/app/components/ExternalLink/ExternalLink";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export default function RequestDemoLink() {
  return (
    <ExternalLink
      className="login-page-right__link"
      href="https://indahash.com/schedule-a-call/"
    >
      <IDHFormattedMessage id="ws_request_demo" defaultMessage="Request Demo" />
    </ExternalLink>
  );
}
